import { Injectable } from '@angular/core';
import { AppEnvService } from '../app-env.service';


export class EndPointItem {
  name: string;
  url: string;

  constructor(name: string, url: string) {
    this.name = name;
    this.url = url;
  }
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  engineEndpoints: EndPointItem[];
  selectedEngineEndpoint: EndPointItem;

  appEndpoints: EndPointItem[];
  selectedAppEndpoint: EndPointItem;

  activeAppEndpoint: EndPointItem;
  activeEngineEndpoint: EndPointItem;

  activeAppBaseUrl: string;
  activeEngineBaseUrl: string;

  activeAppEndpointName: string;
  activeEngineEndpointName: string;

  constructor(private env: AppEnvService,) {

    this.engineEndpoints = [
      new EndPointItem('Refinery2', 'https://refinery2.evidant.com:5000'),
      new EndPointItem('LHDevIP', 'https://10.10.10.80:5000'),
      new EndPointItem('KsDev', 'http://KS-PIDTV2Dev.LH.EVIDANT.COM:5000'),
      new EndPointItem('LHQA', 'https://LH-PIDTV2QA.LH.EVIDANT.COM:5000'),
      new EndPointItem('LHQAIP', 'https://10.10.10.81:5000'),
      new EndPointItem('Local', 'http://localhost:4444'),
      new EndPointItem('Refinery', 'https://refinery.evidant.com:5000'),
      new EndPointItem('Demo', 'http://10.10.10.10:5000'),
      new EndPointItem('QA1', 'http://LH-PIDTV1QA.LH.EVIDANT.COM:5000'),
      new EndPointItem('DTR-Europe', 'https://refineryeu.evidant.com:5000'),
      new EndPointItem('DTR-Mobile', 'https://dtr-mobile.evidant.com:5000'),
      new EndPointItem('RefineryIN', 'https://refineryin.evidant.com:5000'),
      new EndPointItem('DTR-Coney', 'https://refineryct.evidant.com:5000'),
      new EndPointItem('DTR-US', 'https://refineryus.evidant.com:5000'),
      new EndPointItem('DTR-US-IP', 'https://10.10.10.82:5000'),
      new EndPointItem('DTR-WS', 'https://refineryws.evidant.com:5000'),
      new EndPointItem('DTR-WS-IP', 'https://10.101.140.210:5000')
    ];

    this.appEndpoints = [
      new EndPointItem('Refinery2', 'https://refinery2.evidant.com:4000'),
      new EndPointItem('LHDevIP', 'https://10.10.10.80:4000'),
      new EndPointItem('KsDev', 'http://KS-PIDTV2Dev.LH.EVIDANT.COM:4000'),
      new EndPointItem('LHQA', 'https://LH-PIDTV2QA.LH.EVIDANT.COM:4000'),
      new EndPointItem('LHQAIP', 'https://10.10.10.81:4000'),
      new EndPointItem('Local', 'http://localhost:4000'),
      new EndPointItem('Refinery', 'https://refinery.evidant.com:4000'),
      new EndPointItem('Demo', 'http://10.10.10.10:4000'),
      new EndPointItem('QA1', 'http://LH-PIDTV1QA.LH.EVIDANT.COM:4000'),
      new EndPointItem('DTR-Europe', 'https://refineryeu.evidant.com:4000'),
      new EndPointItem('DTR-Mobile', 'https://dtr-mobile.evidant.com:4000'),
      new EndPointItem('RefineryIN', 'https://refineryin.evidant.com:4000'),
      new EndPointItem('DTR-Coney', 'https://refineryct.evidant.com:4000'),
      new EndPointItem('DTR-US', 'https://refineryus.evidant.com:4000'),
      new EndPointItem('DTR-US-IP', 'https://10.10.10.82:4000'),
      new EndPointItem('DTR-WS', 'https://refineryws.evidant.com:4000'),
      new EndPointItem('DTR-WS-IP', 'https://10.101.140.210:4000')
    ];

    if (localStorage.activeAppEndpointName) {
      this.setActiveAppEndpoint(this.appEndpoints.find(item => item.name === localStorage.activeAppEndpointName));
    }
    else {
      this.setActiveAppEndpoint(this.appEndpoints.find(item => item.name === this.env.AppEndpointName()));
    }

    //console.log(`Active AppEndPoint Name: ${localStorage.activeAppEndpointName}`);

    if (localStorage.activeEngineEndpointName) {
      this.setActiveEngineEndpoint(this.engineEndpoints.find(item => item.name === localStorage.activeEngineEndpointName));
    } else {
      this.setActiveEngineEndpoint(this.engineEndpoints.find(item => item.name === this.env.EngineEndpointName()));
    }
  }

  setActiveAppEndpoint(item: EndPointItem): void {
    // Mirrors the existing null-guard in setActiveEngineEndpoint below - if
    // AppEnvService's config wasn't loaded yet (or the configured name matches
    // no entry in the list above), fail safe by leaving the previous/no
    // endpoint in place rather than throwing on `item.name`.
    if (item == null) { return; }

    this.activeAppEndpoint = item;
    this.activeAppEndpointName = item.name;
    this.activeAppBaseUrl = item.url;

    localStorage.activeAppEndpointName = item.name;
  }

  setActiveEngineEndpoint(item: EndPointItem): void {
    if (item == null) { return; }

    this.activeEngineEndpoint = item;
    this.activeEngineBaseUrl = item.url;
    this.activeEngineEndpointName = item.name;

    localStorage.activeEngineEndpointName = item.name;
  }
}
